module.exports = __webpack_public_path__ + "img/0726_V1B.9b67e724.jpg";